import { render, staticRenderFns } from "./CandidateInterviewVirtual.vue?vue&type=template&id=7bd94100&scoped=true&"
import script from "./CandidateInterviewVirtual.vue?vue&type=script&lang=js&"
export * from "./CandidateInterviewVirtual.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInterviewVirtual.vue?vue&type=style&index=0&id=7bd94100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd94100",
  null
  
)

/* custom blocks */
import block0 from "./CandidateInterviewVirtual.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateInterviewVirtual.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VResponsive,VRow})
